export default "__VITE_ASSET__BbBfnWep__"